// extracted by mini-css-extract-plugin
module.exports = {"LoaderSpinner":"LoaderSpinner_LoaderSpinner__1w3Q2","svg":"LoaderSpinner_svg__2Yx2i","progress":"LoaderSpinner_progress__3U2iG"};